/* eslint-disable react/no-multi-comp */
import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { FormattedMessage } from 'react-intl'

import {
    Tooltip,
    TooltipBody,
    TooltipSubtitle,
} from 'react-wot-bootstrap'

import FormattedIndustrialResource from '../FormattedIndustrialResource/FormattedIndustrialResource'

import styles from './EarnedResourceTooltip.scss'
import { EARNED_RESOURCE_TOOLTIP_TITLE } from './translations'

const TITLE_BY_PERIOD = {
    1: (
        <FormattedMessage
            id="clanmanagement.tooltips.earned_resource_body1_1_day"
            defaultMessage="За 1 день"
        />
    ),
    7: (
        <FormattedMessage
            id="clanmanagement.tooltips.earned_resource_body1_7_days"
            defaultMessage="За 7 дней"
        />
    ),
    28: (
        <FormattedMessage
            id="clanmanagement.tooltips.earned_resource_body1_28_days"
            defaultMessage="За 28 дней"
        />
    ),
}

export const EarnedResourceTooltipContent = (props) => {
    const {
        industrialResourceEarnedAsClanmate,
        industrialResourceEarnedAsLegionary,
        industrialResourceEarnedInRandomInClanmatePlatoon,
        industrialResourceEarnedInRandom,
        industrialResourceForClanPurchaseProduct,
        industrialResourceClansupply,
        industrialResource,
        industrialResourceWhole,
    } = props.statistics

    return (
        <TooltipBody>
            <TooltipSubtitle>{EARNED_RESOURCE_TOOLTIP_TITLE}</TooltipSubtitle>
            <div className={styles.base}>
                <div className={styles.period}>
                    <div className={styles.item}>
                        <div className={styles.key}>
                            <span className={styles.keyInner}>
                                {TITLE_BY_PERIOD[props.selectedPeriod]}
                            </span>
                        </div>
                        <div className={styles.value}>
                            <FormattedIndustrialResource size="small" amount={industrialResource} />
                        </div>
                    </div>
                </div>

                <div className={styles.block}>
                    <div className={classNames(styles.icon, styles['icon__strongholds'])} />
                    <div className={styles.content}>
                        <div className={styles.caption}>
                            <FormattedMessage
                                id="clanmanagement.tooltips.earned_resource_body2"
                                defaultMessage="Вылазки и Наступления"
                            />
                        </div>
                        <div>
                            <div className={styles.item}>
                                <div className={styles.key}>
                                    <span className={styles.keyInner}>
                                        <FormattedMessage
                                            id="clanmanagement.tooltips.earned_resource_body3"
                                            defaultMessage="С кланом"
                                        />
                                    </span>
                                </div>
                                <div className={styles.value}>
                                    <FormattedIndustrialResource
                                        size="small"
                                        amount={industrialResourceEarnedAsClanmate}
                                    />
                                </div>
                            </div>
                            <div className={styles.item}>
                                <div className={styles.key}>
                                    <span className={styles.keyInner}>
                                        <FormattedMessage
                                            id="clanmanagement.tooltips.earned_resource_body4"
                                            defaultMessage="Легионером"
                                        />
                                    </span>
                                </div>
                                <div className={styles.value}>
                                    <FormattedIndustrialResource
                                        size="small"
                                        amount={industrialResourceEarnedAsLegionary}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.block}>
                    <div className={classNames(styles.icon, styles['icon__random'])} />
                    <div className={styles.content}>
                        <div className={styles.caption}>
                            <FormattedMessage
                                id="clanmanagement.tooltips.earned_resource_body5"
                                defaultMessage="Случайные бои на X уровне техники"
                            />
                        </div>
                        <div>
                            <div className={styles.item}>
                                <div className={styles.key}>
                                    <span className={styles.keyInner}>
                                        <FormattedMessage
                                            id="clanmanagement.tooltips.earned_resource_body6"
                                            defaultMessage="Во взводе с соклановцем"
                                        />
                                    </span>
                                </div>
                                <div className={styles.value}>
                                    <FormattedIndustrialResource
                                        size="small"
                                        amount={industrialResourceEarnedInRandomInClanmatePlatoon}
                                    />
                                </div>
                            </div>
                            <div className={styles.item}>
                                <div className={styles.key}>
                                    <span className={styles.keyInner}>
                                        <FormattedMessage
                                            id="clanmanagement.tooltips.earned_resource_body7"
                                            defaultMessage="Без соклановцев"
                                        />
                                    </span>
                                </div>
                                <div className={styles.value}>
                                    <FormattedIndustrialResource
                                        size="small"
                                        amount={industrialResourceEarnedInRandom}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    industrialResourceForClanPurchaseProduct > 0 &&
                    <div className={styles.block}>
                    <div className={classNames(styles.icon, styles['icon__purchase'])} />
                    <div className={styles.content}>
                        <div className={styles.caption}>
                            <FormattedMessage
                                id="clanmanagement.tooltips.purchased_resource1"
                                defaultMessage="Помощь клану"
                            />
                        </div>
                        <div>
                            <div className={styles.item}>
                                <div className={styles.key}>
                                    <span className={styles.keyInner}>
                                        <FormattedMessage
                                            id="clanmanagement.tooltips.purchased_resource2"
                                            defaultMessage="Куплено промресурса"
                                        />
                                    </span>
                                </div>
                                <div className={styles.value}>
                                    <FormattedIndustrialResource
                                        size="small"
                                        amount={industrialResourceForClanPurchaseProduct}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }

                {
                    props.showClanQuestsCard &&
                    <div className={styles.block}>
                        <div className={classNames(styles.icon, styles['icon__quests'])} />
                        <div className={styles.content}>
                            <div className={styles.caption}>
                                <FormattedMessage
                                    id="clanmanagement.tooltips.clan_supply_quests1"
                                    defaultMessage="Боевой поход"
                                />
                            </div>
                            <div>
                                <div className={styles.item}>
                                    <div className={styles.key}>
                                        <span className={styles.keyInner}>
                                            <FormattedMessage
                                                id="clanmanagement.tooltips.clan_supply_quests2"
                                                defaultMessage="За выполнение задач похода"
                                            />
                                        </span>
                                    </div>
                                    <div className={styles.value}>
                                        <FormattedIndustrialResource
                                            size="small"
                                            amount={industrialResourceClansupply}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </div>

            <div className={styles.item}>
                <div className={styles.key}>
                    <span className={styles.keyInner}>
                        <FormattedMessage
                            id="clanmanagement.tooltips.earned_resource_body10"
                            defaultMessage="За всё время"
                        />
                    </span>
                </div>
                <div className={styles.value}>
                    <FormattedIndustrialResource size="small" amount={industrialResourceWhole} />
                </div>
            </div>
        </TooltipBody>
    )
}
EarnedResourceTooltipContent.propTypes = {
    selectedPeriod: PropTypes.oneOf([1, 7, 28]).isRequired,
    statistics: PropTypes.shape({
        industrialResourceEarnedAsClanmate: PropTypes.number.isRequired,
        industrialResourceEarnedAsLegionary: PropTypes.number.isRequired,
        industrialResourceEarnedInRandomInClanmatePlatoon: PropTypes.number.isRequired,
        industrialResourceEarnedInRandom: PropTypes.number.isRequired,
        industrialResourceForClanPurchaseProduct: PropTypes.number.isRequired,
        industrialResourceClansupply: PropTypes.number.isRequired,
        industrialResource: PropTypes.number.isRequired,
        industrialResourceWhole: PropTypes.number.isRequired,
    }).isRequired,
    showClanQuestsCard: PropTypes.bool.isRequired,
}

export const NotEarnedResourceTooltip = () => (
    <Tooltip id={NotEarnedResourceTooltip.id}>
        <TooltipBody>
            <FormattedMessage
                id="clanmanagement.tooltips.not_earned_resource_body"
                defaultMessage="Промресурс не заработан"
            />
        </TooltipBody>
    </Tooltip>
)
NotEarnedResourceTooltip.id = 'clanmanagement.tooltip.not_earned_resource'



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/ClanManagement/EarnedResourceTooltip.js